
























































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Voucher, revenueStatuses, VoucherType, Customer } from '@/services/models'
import { Action, Getter } from 'vuex-class'

import CustomerSelector from '@/components/CustomerSelector.vue'
import DatePicker from '@/components/DatePicker.vue'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    CustomerSelector,
    DatePicker,
  },
})
export default class EditvoucherModal extends Vue {

  @Action('firestore/writeVoucher')
  private writeVoucher!: (voucher: Voucher) => Promise<Voucher>

  private isModalOpen: boolean = false

  private title: string = ''

  private localCopy: Voucher = new Voucher()

  private formatters = formatters

  private get typeChoices(): Array<{ value: VoucherType, text: string }> {
    return [
      { value: 'receipt', text: 'ใบสำคัญรับ' },
      { value: 'payment', text: 'ใบสำคัญจ่าย' },
    ]
  }

  public async _commit(value: Voucher, buttonEvent: any) {
    // Validate
    console.log('Committed!!', buttonEvent)

    // Invoke API
    await this.writeVoucher(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Voucher) {
    // emit!
  }

  public onCustomerSelected(customer: Customer) {
    this.localCopy.customer = customer
  }

  // PUBLIC Interface

  public edit(data: Voucher) {
    this.show()
    this.title = `Edit Revenue: ${data.id}`
    throw new Error('Implementation is reqired.')
  }

  public create() {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Revenue'
    this.localCopy = new Voucher()
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
